import { CommonBaseData } from "../shared/data/common-base-data";

export class N5111InputData extends CommonBaseData {

  // ＡＰＩ使用可否フラグ
  public apiShiyoKahiFuragu: boolean;
  // 最大選択数
  public saidaiSentakusu: number;

}



// WEBPACK FOOTER //
// ./src/app/modules/n511/n5111-input-data.ts